import { render, staticRenderFns } from "./AcademyView.vue?vue&type=template&id=59305d92&scoped=true"
import script from "./AcademyView.vue?vue&type=script&lang=js"
export * from "./AcademyView.vue?vue&type=script&lang=js"
import style0 from "./AcademyView.vue?vue&type=style&index=0&id=59305d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59305d92",
  null
  
)

export default component.exports